const Header = ({ saveSpace }) => {
  return (
    <div>
      <div className={saveSpace ? "container" : "container pb-1"}>
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <img
              src={"/bingoHeaderBox.png?v=3"}
              alt="headerbox"
              className="bingoHeaderBox hithere"
              style={{ width: saveSpace ? "50%" : "" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
